import { RootState } from "../app/store";

export const selectIsLoading = (state: RootState) =>
  state.tournaments.status === "loading" || state.users.status === "loading";
